var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.RoomingMap = YouLi.Trip.RoomingMap ? YouLi.Trip.RoomingMap : {};

(function (YouLi) {
    (function (Trip) {
        (function (RoomingMap) {

            YouLi.Trip.RoomingMap.TripPackagesData = undefined;
            YouLi.Trip.RoomingMap.TripPackageRoomsData = undefined;

            YouLi.Trip.RoomingMap.ZoomboxIdentifier = "zoombox_";
            YouLi.Trip.RoomingMap.RoomIdentifier = "room_";
            YouLi.Trip.RoomingMap.ViewportOriginalViewBoxValue;

            YouLi.Trip.RoomingMap.RoomingMapSvg = undefined;
            YouLi.Trip.RoomingMap.CurrentViewBox = undefined;

            YouLi.Trip.RoomingMap.FormatPackageSelectOption = function (item) {

                if (item.id === '') { // adjust for custom placeholder values
                    return item.text;
                }

                const itemColor = item.color;
                if (!itemColor) {
                    return item.text;
                }

                let $item = $('<span><span class="package-color-box"></span><span class="text"></span></span>');

                // avoiding string concatenation to prevent script injection
                $item.find("span.package-color-box").css("background-color", itemColor);
                $item.find("span.text").text(item.text);

                return $item;
            }

            YouLi.Trip.RoomingMap.ShowRoomDialog = function (roomName) {
                YouLi.Common.UI.ShowLoading();

                const tripId = $("#TripId").val();
                const inviteeId = $("#InviteeId").val();
                const previewMode = $("#PreviewMode").val();

                $.ajax({
                    url: `/trip/trippackageroomdetailsdialog/?tripid=${tripId}&inviteeid=${inviteeId}&roomname=${roomName}&preview=${previewMode}`,
                    type: "GET",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    complete: function (response) {
                        YouLi.Common.UI.HideLoading();
                        if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred when loading.");
                        }
                        else {
                            $("#RoomDetailsDialogContent").html(response.responseText);
                            $('#RoomDetailsDialog').modal('show');
                            YouLi.Common.UI.Init(); // needed to get tooltips to work in loaded dialog
                        }
                    }
                });
            }

            YouLi.Trip.RoomingMap.UpdateCurrentViewBox = function () {
                var viewBoxFromElement = YouLi.Trip.RoomingMap.RoomingMapSvg.getAttribute('viewBox').split(' ');
                YouLi.Trip.RoomingMap.CurrentViewBox = {
                    x: viewBoxFromElement[0],
                    y: viewBoxFromElement[1],
                    width: viewBoxFromElement[2],
                    height: viewBoxFromElement[3]
                };
            }

            YouLi.Trip.RoomingMap.Zoom2x = function () {
                if ($('#RoomingMap-Svg-Viewport') && $('#RoomingMap-Svg-Viewport').length > 0) {

                    const xAtZoom = $('#RoomingMap-Svg-Viewport').attr("width") / 4;
                    const yAtZoom = $('#RoomingMap-Svg-Viewport').attr("height") / 4;
                    const zoomWidth = $('#RoomingMap-Svg-Viewport').attr("width") / 2;
                    const zoomHeight = $('#RoomingMap-Svg-Viewport').attr("height") / 2;

                    $('#RoomingMap-Svg-Viewport')[0].setAttribute('viewBox', [xAtZoom, yAtZoom, zoomWidth, zoomHeight].join(' '));

                    $(".zoom-in").addClass("disabled");
                    $(".zoom-out").removeClass("disabled");

                    YouLi.Trip.RoomingMap.UpdateCurrentViewBox();
                }
            };


            YouLi.Trip.RoomingMap.ClearZoom = function () {
                if ($('#RoomingMap-Svg-Viewport') && $('#RoomingMap-Svg-Viewport').length > 0) {
                    $('#RoomingMap-Svg-Viewport')[0].setAttribute('viewBox', [0, 0, $('#RoomingMap-Svg-Viewport').attr("width"), $('#RoomingMap-Svg-Viewport').attr("height")].join(' '));

                    $(".zoom-in").removeClass("disabled");
                    $(".zoom-out").addClass("disabled");

                    YouLi.Trip.RoomingMap.UpdateCurrentViewBox();
                }
            };

            YouLi.Trip.RoomingMap.SelectRoom = function (roomName) {
                $('#RoomDetailsDialog').modal('hide');

                if (YouLi.Trip.Payments) {
                    let roomData = YouLi.Trip.RoomingMap.TripPackageRoomsData.find(r => r.Name == roomName);
                    YouLi.Trip.Payments.UpdateTripPackage(roomData.TripPackageId, roomData.Id)
                        .then(() => {
                            YouLi.Trip.GoToSection("paymentdetails");

                            // clear any previous selection and select the new one
                            $(`#RoomingMapImage .selected-self`).removeClass("room-unavailable").removeClass("selected-self");
                            $(`#RoomingMapImage #${YouLi.Trip.RoomingMap.RoomIdentifier}${roomData.TripPackageCode}_${roomData.Name}`).addClass("room-unavailable").addClass("selected-self");

                            $("#PreselectedPackageRoomId").val(roomData.Id);    // update response dialog value
                        });
                }

                ForceFooterUpdate();
            };

            YouLi.Trip.RoomingMap.InitialiseUI = function () {

                const isZoomBox = rectId => rectId.startsWith(YouLi.Trip.RoomingMap.ZoomboxIdentifier);
                const isRoom = rectId => rectId.startsWith(YouLi.Trip.RoomingMap.RoomIdentifier);

                const imageURL = $("#RoomingMapImage").data("image-url");

                $.ajax({
                    url: imageURL,
                    cache: true,
                    type: "GET",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    complete: function (response) {
                        YouLi.Common.UI.HideLoading();
                        if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred when loading.");
                            return;
                        }
                        else if (response.status != 200) {
                            return; // leave the rooming map empty
                        }

                        $("#RoomingMapImage").html(response.responseText);

                        YouLi.Trip.RoomingMap.RoomingMapSvg = document.getElementById("RoomingMap-Svg-Viewport");

                        //get intial viewbox coordinates and width and height only when svg loads
                        //use these coordinates and with&height to restore zoom level to original
                        if (!YouLi.Trip.RoomingMap.ViewportOriginalViewBoxValue) {
                            var viewPortOriginal = YouLi.Trip.RoomingMap.RoomingMapSvg.getBBox();
                            YouLi.Trip.RoomingMap.ViewportOriginalViewBoxValue = [viewPortOriginal.x, viewPortOriginal.y, viewPortOriginal.width, viewPortOriginal.height].join(' ');
                        }

                        //only zoombox and individual room uses path as tag
                        //register event handler to individual rooms
                        //set opacity of individual room to 0.
                        $("#RoomingMapImage path").each(function () {
                            var rectId = $(this).attr("id");

                            if (isZoomBox(rectId)) {
                                $(this).css("pointer-events", "none");
                                $(this).attr("opacity", "0");
                            }
                            else if (isRoom(rectId)) {
                                //one individual room has opacity: 0 -> room available
                                $(this).attr("opacity", "0");

                                //register on click event to rooms
                                $(document).off("click", `#${rectId}`);
                                $(document).on("click", `#${rectId}`, function () {
                                    const roomElementId = $(this).attr("id");
                                    const roomName = roomElementId.substring(roomElementId.lastIndexOf("_") + 1);
                                    YouLi.Trip.RoomingMap.ShowRoomDialog(roomName);
                                })
                            }
                        });

                        // Set up opacity of booked rooms
                        YouLi.Trip.RoomingMap.TripPackageRoomsData.forEach((roomData) => {

                            if (roomData.IsBooked)
                                $(`#RoomingMapImage #${YouLi.Trip.RoomingMap.RoomIdentifier}${roomData.TripPackageCode}_${roomData.Name}`).addClass("room-unavailable");

                            if (roomData.IsSelectedByCurrentInvitee)
                                $(`#RoomingMapImage #${YouLi.Trip.RoomingMap.RoomIdentifier}${roomData.TripPackageCode}_${roomData.Name}`).addClass("room-unavailable").addClass("selected-self");

                        });

                        // Set up panning.  First, we select the SVG into the page

                        // If browser supports pointer events
                        if (window.PointerEvent) {
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('pointerdown', onPointerDown); // Pointer is pressed
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('pointerup', onPointerUp); // Releasing the pointer
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('pointerleave', onPointerUp); // Pointer gets out of the SVG area
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('pointermove', onPointerMove); // Pointer is moving
                        } else {
                            // Add all mouse events listeners fallback
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('mousedown', onPointerDown); // Pressing the mouse
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('mouseup', onPointerUp); // Releasing the mouse
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('mouseleave', onPointerUp); // Mouse gets out of the SVG area
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('mousemove', onPointerMove); // Mouse is moving

                            // Add all touch events listeners fallback
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('touchstart', onPointerDown); // Finger is touching the screen
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('touchend', onPointerUp); // Finger is no longer touching the screen
                            YouLi.Trip.RoomingMap.RoomingMapSvg.addEventListener('touchmove', onPointerMove); // Finger is moving
                        }



                        /******* Panning functions *******/

                        // This function returns an object with X & Y values from the pointer event
                        function getPointFromEvent(event) {
                            var point = { x: 0, y: 0 };
                            // If even is triggered by a touch event, we get the position of the first finger
                            if (event.targetTouches) {
                                point.x = event.targetTouches[0].clientX;
                                point.y = event.targetTouches[0].clientY;
                            } else {
                                point.x = event.clientX;
                                point.y = event.clientY;
                            }

                            return point;
                        }

                        // This variable will be used later for move events to check if pointer is down or not
                        var isPointerDown = false;

                        // This variable will contain the original coordinates when the user start pressing the mouse or touching the screen
                        var pointerOrigin = {
                            x: 0,
                            y: 0
                        };

                        // Function called by the event listeners when user start pressing/touching
                        function onPointerDown(event) {
                            isPointerDown = true; // We set the pointer as down

                            // We get the pointer position on click/touchdown so we can get the value once the user starts to drag
                            var pointerPosition = getPointFromEvent(event);
                            pointerOrigin.x = pointerPosition.x;
                            pointerOrigin.y = pointerPosition.y;
                        }

                        // We save the original values from the viewBox
                        YouLi.Trip.RoomingMap.UpdateCurrentViewBox();

                        // The distances calculated from the pointer will be stored here
                        var newViewBox = {
                            x: 0,
                            y: 0
                        };

                        // Calculate the ratio based on the viewBox width and the SVG width
                        var ratio = YouLi.Trip.RoomingMap.CurrentViewBox.width / YouLi.Trip.RoomingMap.RoomingMapSvg.getBoundingClientRect().width;
                        window.addEventListener('resize', function () {
                            ratio = YouLi.Trip.RoomingMap.CurrentViewBox.width / YouLi.Trip.RoomingMap.RoomingMapSvg.getBoundingClientRect().width;
                        });

                        // Function called by the event listeners when user start moving/dragging
                        function onPointerMove(event) {
                            // Only run this function if the pointer is down
                            if (!isPointerDown) {
                                return;
                            }
                            // This prevent user to do a selection on the page
                            event.preventDefault();

                            // Get the pointer position
                            var pointerPosition = getPointFromEvent(event);

                            // We calculate the distance between the pointer origin and the current position
                            // The viewBox x & y values must be calculated from the original values and the distances
                            newViewBox.x = YouLi.Trip.RoomingMap.CurrentViewBox.x - ((pointerPosition.x - pointerOrigin.x) * ratio);
                            newViewBox.y = YouLi.Trip.RoomingMap.CurrentViewBox.y - ((pointerPosition.y - pointerOrigin.y) * ratio);

                            // We create a string with the new viewBox values
                            // The X & Y values are equal to the current viewBox minus the calculated distances
                            var viewBoxString = `${newViewBox.x} ${newViewBox.y} ${YouLi.Trip.RoomingMap.CurrentViewBox.width} ${YouLi.Trip.RoomingMap.CurrentViewBox.height}`;
                            // We apply the new viewBox values onto the SVG
                            YouLi.Trip.RoomingMap.RoomingMapSvg.setAttribute('viewBox', viewBoxString);

                            //document.querySelector('.viewbox').innerHTML = viewBoxString;
                        }

                        function onPointerUp() {
                            // The pointer is no longer considered as down
                            isPointerDown = false;

                            // We save the viewBox coordinates based on the last pointer offsets
                            YouLi.Trip.RoomingMap.CurrentViewBox.x = newViewBox.x;
                            YouLi.Trip.RoomingMap.CurrentViewBox.y = newViewBox.y;
                        }

                        /******* End panning functions *******/
                    }
                });

                //$("#RoomingMapImage").load(imageURL, function () {

                    
                //});

                $("#RoomingMapPackageId").select2({
                    theme: "bootstrap",
                    dropdownCssClass: "trip-page-select",
                    templateResult: YouLi.Trip.RoomingMap.FormatPackageSelectOption,
                    templateSelection: YouLi.Trip.RoomingMap.FormatPackageSelectOption,
                    minimumResultsForSearch: Infinity,   // hide search bar at the top
                    placeholder: {
                        id: "",
                        text: "None selected",
                        selected: 'selected'
                    },
                    allowClear: true,
                    data: YouLi.Trip.RoomingMap.TripPackagesData
                });

                $('#RoomingMapPackageId').on('select2:select', function (e) {
                    let svgZoomBoxId = `${YouLi.Trip.RoomingMap.ZoomboxIdentifier}${e.params.data.code}`;

                    const zoomRange = document.getElementById(svgZoomBoxId).getBBox();
                    $('#RoomingMap-Svg-Viewport')[0].setAttribute('viewBox',
                        [zoomRange.x, zoomRange.y, zoomRange.width, zoomRange.height].join(' '));

                    $(".zoom-in").addClass("disabled");
                    $(".zoom-out").removeClass("disabled");

                    YouLi.Trip.RoomingMap.UpdateCurrentViewBox();
                });


                $('#RoomingMapPackageId').on('select2:clear', function (e) {
                    YouLi.Trip.RoomingMap.ClearZoom();
                });


                $(document).off("click", ".zoom-in");
                $(document).on("click", ".zoom-in", function () {

                    // clear selection
                    $('#RoomingMapPackageId').val(null).trigger('change');

                    YouLi.Trip.RoomingMap.Zoom2x();
                });

                $(document).off("click", ".zoom-out");
                $(document).on("click", ".zoom-out", function () {

                    // clear selection
                    $('#RoomingMapPackageId').val(null).trigger('change');

                    YouLi.Trip.RoomingMap.ClearZoom();
                });

                $(document).off("click", "#SelectRoomButton");
                $(document).on("click", "#SelectRoomButton", function () {
                    YouLi.Trip.RoomingMap.SelectRoom($(this).data("selected-room-name"));
                });

            };

            var ForceFooterUpdate = function () {
                YouLi.Trip.FooterUpdatesPaused = false;
                YouLi.Trip.UpdateResponseFooter(runOnce = true, checkTripUpdates = false);
            };

            $(function () {

                YouLi.Trip.RoomingMap.InitialiseUI();

            });

        }(YouLi.Trip.RoomingMap ? YouLi.Trip.RoomingMap : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));